import { render, staticRenderFns } from "./CardProjectMember.vue?vue&type=template&id=2ce1a9d6&"
import script from "./CardProjectMember.vue?vue&type=script&lang=js&"
export * from "./CardProjectMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports